import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

const url = import.meta.env.VITE_SUPABASE_URL;
// Prefer the new "publishable" key format (sb_publishable_...), fall back to
// the legacy "anon" key for projects that haven't rotated yet. The Supabase
// JS client accepts both transparently — this is purely about matching the
// name the user sees in the current dashboard UI.
const clientKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !clientKey) {
  // Fail loudly at startup — a silent mis-config would let the app render
  // while every query fails, which is the worst possible UX for a patient tool.
  throw new Error(
    'Missing VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY. ' +
      'Copy .env.example to .env.local.',
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(url, clientKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'terp-track-auth',
  },
  global: {
    headers: { 'x-application-name': 'terp-track-web' },
  },
});
